/**
 * The users the AI agents work their calls as. It mirrors AI_AGENT_USERS in
 * the cloud functions settings, and it is a list of ids because there is
 * nothing else to go on: their user documents carry role OPERATOR like
 * anyone else's.
 */
export const AI_USER_IDS = ['aiWhatsappAgent', 'aiPhoneAgent'];

export const isAiUser = (userId) => AI_USER_IDS.includes(userId);
